module.exports = __webpack_public_path__ + "static/media/Ad.cc73cdda.png";